var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetManagementIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1501 40.8501V76H22.0782C8.24621 76 0.000244141 67.754 0.000244141 53.9221V40.8501H35.1501Z",
    fill: "#405072"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9997 22.0779V35.1499H40.8499V0H53.9218C67.7538 0 75.9997 8.24597 75.9997 22.0779Z",
    fill: "#082072"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1499 0V35.1499H0V22.0779C0 8.24597 8.24597 0 22.0779 0H35.1499Z",
    fill: "#606F8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9997 40.8501V53.9221C75.9997 67.754 67.7538 76 53.9218 76H40.8499V40.8501H75.9997Z",
    fill: "#606F8E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetManagementIcon);
export default __webpack_public_path__ + "static/media/asset_management_icon.1a2b3e442a7fdb5602957d9320a2846f.svg";
export { ForwardRef as ReactComponent };